import React from 'react'
import Navbar from './components/navbar'
import Header from './components/header'
import './Hero.css';




export default function Hero() {
  return (
    <>
      <Navbar />
      <Header />
    </>
  )
}
